import { configureStore } from "@reduxjs/toolkit";
import { actionsSlice, loaderSlice,filterValuesSlice, filterSlice, ptpSlice, agentSlice, trendSlice, amountSlice, dpdSlice, timelineSlice, lendFilterSlice} from "../reducers";

const store = configureStore({
    reducer: {
        loader: loaderSlice.reducer,
        actions: actionsSlice.reducer,
        agent: agentSlice.reducer,
        ptp: ptpSlice.reducer,
        trend:trendSlice.reducer,
        amount:amountSlice?.reducer,
        filter: filterSlice?.reducer,
        dpdData: dpdSlice?.reducer,
        timelineData: timelineSlice?.reducer,
        agentData: agentSlice?.reducer,
        filterValues: filterValuesSlice?.reducer,
        lendFilter:lendFilterSlice?.reducer
    }
})

export default store;